// Dashboard "Recent readings" panel. Up to 5 rows, kit's `.read` pattern:
//   date · title + ctx · score pill · arrow
//
// Distinct from EarlierRow (used in /reports). The dashboard's recent list
// is denser and uses uppercase mono ctx text per the kit.

import { Link } from "react-router";
import { ScorePill } from "./ScorePill";
import type { AnalysisListItem, CallType } from "../lib/api";
import { CALL_TYPE_LABELS } from "../lib/api";

export function RecentReadingsList({ items, total }: { items: AnalysisListItem[]; total?: number }) {
  return (
    <div className="kpanel tight">
      <div className="kpanel-h">
        <h3>Recent readings</h3>
        <span className="meta">
          {total != null ? `Last ${items.length} of ${total}` : `Last ${items.length}`}
        </span>
      </div>
      {items.map((item) => {
        const date = formatRowDate(item.meetingDate ?? item.createdAt);
        const title = item.meetingTitle?.trim() || CALL_TYPE_LABELS[item.callType];
        const ctx = humaniseCtx(item.callType);
        return (
          <Link key={item.id} to={`/reports/${item.id}`} className="read">
            <span className="when">{date}</span>
            <span className="what">
              {title}
              <span className="ctx">{ctx}</span>
            </span>
            {typeof item.overallScore === "number" ? (
              <ScorePill score={item.overallScore} />
            ) : (
              <span />
            )}
            <span className="arr" aria-hidden="true">→</span>
          </Link>
        );
      })}
    </div>
  );
}

function formatRowDate(unixSeconds: number): string {
  const d = new Date(unixSeconds * 1000);
  if (isNaN(d.getTime())) return "";
  return d.toLocaleDateString("en-GB", { day: "2-digit", month: "short" });
}

function humaniseCtx(callType: CallType): string {
  return CALL_TYPE_LABELS[callType];
}
